<template>
  <div class="upload-container">
    <div class="upload-list">
      <!-- <el-upload
        v-if="hasPermission"
        class="card addCard"
        accept="image/*"
        action="xxx"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="onImageChange"
      >
        <img src="@/assets/img/planAdd.png" class="planAdd">
        <span class="addTitle">{{ $t('visual.uploadImg') }}</span>
        <span>MP4格式,大小150M以内,时长不超过1分钟</span>
      </el-upload> -->
      <el-upload
        class="card addCard"
        accept="video/*,image/*"
        action="xxx"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="onUpload"
      >
        <img src="@/assets/img/planAdd.png" class="planAdd">
        <span class="addTitle">{{ $t('tianmu.UploadIorV') }}</span>
        <span class="addSize">{{ $t('tianmu.videoSize') }}</span>
      </el-upload>
    </div>
    <HistoryList ref="historyList" :show-entry="8" :device="device" />
    <CreateCheckModal
      :visible="isCreateImgVisible"
      :type="modalType"
      :image-url="currentCreateImg"
      :video-url="videoUrl"
      :video-thumbnail="videoThumbnail"
      :show-entry="8"
      :loading="isUploadLoading"
      :device="device"
      @close="isCreateImgVisible=false"
      @refreshList="refreshList"
    />
  </div>
</template>
<script>
import CreateCheckModal from './CreateCheckModal.vue';
import { loadAsyncImg } from '@/components/DesignCanvas/index';
import { UploadFile } from "@/axios/ICommon.js";
import HistoryList from './HistoryList.vue';
import Card from './Card.vue';
import {
  FindSceneListByPage,
} from '@/axios/IScene.js'
import { alerterror, warning, alertsuccess } from '@/assets/js/common.js'

export default {
  components: {
    CreateCheckModal,
    Card,
    HistoryList
  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      modalType: 1, // 1 图片 2 视频 3 ai生成
      isUploadLoading: false,
      hasPermission: true,
      uploadImg: '',
      videoUrl: '',
      videoThumbnail: '',
      isCreateImgVisible: false,
    }
  },

  watch: {
  },
  mounted() {
  },
  destroyed(){
  },
  methods: {

    onUpload(file) { 
          // 获取文件的类型
      const fileType = file.raw.type
      
      if (fileType.startsWith('image/')) {
        console.log('这是一个图片文件')
        this.onImageChange(file);
        // 处理图片的逻辑
      } else if (fileType.startsWith('video/')) {
        console.log('这是一个视频文件')
        this.handleVideoUpload(file);
        // 处理视频的逻辑
      } else {
        console.log('文件类型不支持')
        // 可以在这里给出错误提示
      }
  
    },

    async onImageChange(file) {
      this.isUploadLoading = true;
      this.isCreateImgVisible = true;

      const url = URL.createObjectURL(file.raw);
      const img = await loadAsyncImg(url);

      const { width, height } = img;

      const formData = new FormData();

      formData.append("file", file.raw);

      UploadFile(formData, (res) => {
        if (res.StatusCode === this.$store.state.rightStatusCode) {
          this.modalType = 1;
          this.currentCreateImg = res.Result.RootPath + res.Result.FilePath;
          this.isUploadLoading = false;
        };
      });
    },
    async handleVideoUpload(file) { 
      this.isUploadLoading = true;

      const errors = await this.validateVideoFile(file)
      
      if (errors.length > 0) {
        this.showFileValidationError(errors)
        return
      }

      try {
        // 获取视频第一帧作为缩略图
        const thumbnail = await this.generateVideoThumbnail(file.raw)
        this.videoThumbnail = thumbnail

        await this.uploadVideoFile(file)

        this.isUploadLoading = false;
      } catch (error) {
        console.error('视频处理错误:', error)
        this.isUploadLoading = false;
        this.$message.error(this.$t('tianmu.videoProcessError'))
      }
    },

    async uploadVideoFile(file) {
      function base64ToBlob(base64, mimeType = 'image/png') {
        const byteString = atob(base64.split(',')[1])
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ab], { type: mimeType })
      }

      const formData = new FormData();

      // 将 base64 转换为 Blob
      const blob = base64ToBlob(this.videoThumbnail, 'image/png') // 或根据实际 MIME 类型替换
      formData.append('file', blob, 'thumbnail.png') // 给文件一个名字

      this.isCreateImgVisible = true;

      //3. 执行上传操作
      const res = await UploadFile(formData)
      if (res.StatusCode !== this.$store.state.rightStatusCode) {
        alerterror(this, res.StatusCode)
        return
      }
      const { FilePath, RootPath } = res?.Result || {}
      this.videoThumbnail = `${RootPath}${FilePath}`
      this.fileInfo = file

      try {
        this.modalType = 2;
        // this.videoUrl = URL.createObjectURL(file.raw)
        const formVideoData = new FormData()

        formVideoData.append('file', file.raw)

        //3. 执行视频上传操作
        const videoRes = await UploadFile(formVideoData)

        const { FilePath: VideoFilePath, RootPath: VideoRootPath } = videoRes?.Result || {};

        this.videoUrl = `${VideoRootPath}${VideoFilePath}`

      } catch (error) {
        // console.error('上传失败:', error)
      } finally {
        //this.loading = false
      }
    },

    async validateVideoFile(file) {
      const errors = []
      const maxSize = 150 * 1024 * 1024 // 150MB

      if (file.size > maxSize) {
        errors.push(this.$t('tianmu.onlyVideoSize'));
      }

      if (file.raw.type !== 'video/mp4') {
        errors.push(this.$t('tianmu.onlyMp4Format'));
      }

      const videoInfo = await this.extractVideoInfo(file)

      if (!this.validateVideoDuration(videoInfo.duration)) {
        errors.push(this.$t('tianmu.onlyVideoTime'));
      }

      return errors
    },

    extractVideoInfo(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.src = URL.createObjectURL(file.raw)

        video.onloadedmetadata = () => {
          URL.revokeObjectURL(video.src)
          resolve({
            duration: video.duration,
          })
        }

        video.onerror = () => {
          URL.revokeObjectURL(video.src)
          reject(new Error('Invalid video file'))
        }
      })
    },

    // 生成视频缩略图
    async generateVideoThumbnail(videoFile) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        // 创建对象URL
        const videoUrl = URL.createObjectURL(videoFile)
        video.src = videoUrl

        // 必须设置的属性以避免浏览器限制
        video.muted = true // 静音是自动播放的必要条件
        video.playsInline = true // 在移动端需要
        video.setAttribute('crossorigin', 'anonymous') // 处理跨域问题

        // 定义事件处理函数
        const onCanPlay = () => {
          try {
            video.currentTime = 0.1 // 使用0.1比0更可靠
          } catch (err) {
            cleanup()
            reject(new Error('')) // 设置播放位置失败
          }
        }

        const onSeeked = () => {
          try {
            // 确保视频已准备好
            if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
              throw new Error('') // 视频数据未准备好
            }

            canvas.width = video.videoWidth || 320
            canvas.height = video.videoHeight || 240

            context.drawImage(video, 0, 0, canvas.width, canvas.height)
            const thumbnailUrl = canvas.toDataURL('image/jpeg', 0.8)
            //要把视频缩略图传上去

            cleanup()
            resolve(thumbnailUrl)
          } catch (error) {
            cleanup()
            reject(error)
          }
        }

        const onError = e => {
          cleanup()
          reject(new Error('')) // `视频加载错误: ${e.target.error ? e.target.error.message : '未知错误'}
        }

        // 超时处理
        const timeoutId = setTimeout(() => {
          cleanup()
          reject(new Error('')) // 视频加载超时
        }, 10000)

        // 统一的清理函数
        const cleanup = () => {
          clearTimeout(timeoutId)
          video.removeEventListener('canplay', onCanPlay)
          video.removeEventListener('seeked', onSeeked)
          video.removeEventListener('error', onError)
          URL.revokeObjectURL(videoUrl)
          video.src = ''
        }

        // 添加事件监听器
        video.addEventListener('canplay', onCanPlay, { once: true })
        video.addEventListener('seeked', onSeeked, { once: true })
        video.addEventListener('error', onError, { once: true })

        // 安全加载视频
        try {
          const loadPromise = video.load()
          if (loadPromise) {
            loadPromise.catch(err => {
              cleanup()
              reject(new Error('')) // `视频加载失败: ${err.message}`
            })
          }
        } catch (err) {
          cleanup()
          reject(new Error('')) // `视频初始化失败: ${err.message}`
        }
      })
    },

     validateVideoDuration(duration) {
      return duration <= 60 // 60秒限制
    },

    refreshList() {
      // 通过 ref 调用子组件的 refreshList 方法
      if (this.$refs.historyList) {
        this.$refs.historyList.refreshList();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-container {
  .addCard {
    width: 180px;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #000000;
    background: #f7f7f7;
    flex-direction: column;
    border-radius: 4px;


    .planAdd {
      width: 20px;
      height: 20px;
    }
    .addTitle {
      font-size: 16px;
      color: #000000;
      line-height: 20px;
      margin: 5px;
    }
  }
}

.addCard ::v-deep .el-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ai-pic_prolist_prolist {
    padding: 20px;

    &_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      font-size: 16px;
      
      span {
        color: #3F9EFE;
        cursor: pointer;
      }
    }

    &_loading {
      color: #fff;
    }


    &_container {
      display: flex;

      li {
        position: relative;
        margin-right: 20px;
      }
    }
  }
.upload-list {
  display: flex;
  align-items: center;

  & > div {
    margin-right: 20px;
  }
}
</style>
